import { createApi } from '@reduxjs/toolkit/query/react'
import { CONSENT_FORMS_LIST, CONSNET_FORM_VIEW, MANAGE_DISCAHARGE_LIST_NEW, MANAGE_DISCHARGE_LIST, MANAGE_DISCHARGE_VIEW } from 'config/apiPaths';
import axiosBaseQuery from "utils/axios/axiosBaseQuery"

export const consentFormApi = createApi({
    reducerPath: 'consentApi',
    baseQuery: axiosBaseQuery({
        baseUrl: "/consent",
    }),
    tagTypes: ["consentFormsList", "consentFormDetails"],
    endpoints: (builder) => ({
        // get disharge list
        getConsentFormsList: builder.query({
            query: ({ search = "", parentId, clientId, page = 1, limit = 10, sort = { column: "id", direction: "DESC" } }) => {
                return ({
                    method: "PATCH",
                    url: `${CONSENT_FORMS_LIST}/${parentId}/${clientId}`,
                    data: { search, page, limit, sort },
                })
            },
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["consentFormsList"]
        }),

        getConsentFormDetails: builder.query({
            query: ({ id }) => ({
                method: "GET",
                url: `${CONSNET_FORM_VIEW}/${id}`
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["consentFormDetails"]
        }),
    }),
})

export const {
    useGetConsentFormsListQuery,
    useGetConsentFormDetailsQuery,
} = consentFormApi;